<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-等级管理-门店自提核销
  -->
  <el-dialog title="微信付款" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" width="30%">
      <el-form size="small" label-width="100px">
        <el-form-item label="提现密码">
          <el-input v-model="password" type="text" style="width: 200px;"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible">取 消</el-button>
          <el-button type="primary" @click="WxPay">确认</el-button>
      </div>
  </el-dialog>
</template>

<script>
  import PlusApi from '@/api/plus.js';
  export default {
    data() {
        return {
          password:'',
          /*是否显示*/
          dialogVisible: true,

      };
    },
    props: ['open_wxpay', 'id'],
    created() {
      this.dialogVisible = this.open_wxpay;
    },
    methods: {
    /*微信打款*/
    WxPay(e) {
      let self = this;
      console.log(self.id)
      PlusApi.WxPay(
        {
          id: self.id,
          password: self.password
        },
        true
      )
        .then(data => {
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.dialogFormVisible();
          }
        })
        .catch(error => {});
    },
    /*关闭弹窗*/
    dialogFormVisible() {
        this.$emit('closeDialog', {openDialog: false});
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/agent/cash/dialog/WxPay.vue